import * as React from 'react';

import { DescriptionPage_SelfServeConfiguration_AboutModule_SubsectionName as AboutModuleSubsectionName } from '__generated__/graphql-types';

import { Grid } from '@coursera/cds-core';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import type { ProductOverviewModuleConfig } from 'bundles/unified-description-page-common/types/moduleConfig';

type Props = {
  config?: ProductOverviewModuleConfig;
  skills?: React.ReactNode;
  description?: React.ReactNode;
  details?: React.ReactNode;
};

export const AboutSubmoduleRenderer = ({ config, skills, description, details }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  if (!config?.aboutModule?.subsections?.length) {
    return null;
  }

  if (enableXDPRedesign) {
    const aboutSection = config?.aboutModule?.subsections?.find((subsection) => {
      return subsection.name === AboutModuleSubsectionName.LearningOutcomes;
    });

    const skillsSection = config?.aboutModule?.subsections?.find((subsection) => {
      return subsection.name === AboutModuleSubsectionName.Skills;
    });

    const includedSection = config?.aboutModule?.subsections?.find((subsection) => {
      return subsection.name === AboutModuleSubsectionName.DetailsToKnow;
    });

    return (
      <Grid item container spacing={24}>
        {aboutSection && (
          <Grid item xs={12} md={6}>
            {description}
          </Grid>
        )}
        {skillsSection && (
          <Grid item xs={12} md={3}>
            {skills}
          </Grid>
        )}
        {includedSection && (
          <Grid item xs={12} md={3}>
            {details}
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <>
      {config?.aboutModule?.subsections?.map((subsection) => {
        switch (subsection.name) {
          case AboutModuleSubsectionName.LearningOutcomes:
            return <React.Fragment key={AboutModuleSubsectionName.LearningOutcomes}>{description}</React.Fragment>;
          case AboutModuleSubsectionName.Skills:
            return <React.Fragment key={AboutModuleSubsectionName.Skills}>{skills}</React.Fragment>;
          case AboutModuleSubsectionName.DetailsToKnow:
            return <React.Fragment key={AboutModuleSubsectionName.DetailsToKnow}>{details}</React.Fragment>;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AboutSubmoduleRenderer;
